/* istanbul ignore file */

import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";
import NotFound from "../views/errors/NotFound";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "*",
    name: "Error404",
    component: NotFound,
    meta: {
      title: "Page not found"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach(to => {
  if (to.meta.title) document.title = `${to.meta.title} » Chris Sorrells`;
  else document.title = "Chris Sorrells";
});

export default router;
